function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Grupo_712",
  "data-name": "Grupo 712",
  transform: "translate(-230.403 -150.2)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_941",
  "data-name": "Caminho 941",
  d: "M242.2,153.107v12.862a.531.531,0,0,1-.531.531h-9.631a.532.532,0,0,1-.532-.531V153.107",
  fill: "none",
  stroke: "#757575",
  strokeMiterlimit: 10,
  strokeWidth: 0.6
}), /*#__PURE__*/React.createElement("rect", {
  id: "Ret\\xE2ngulo_1442",
  "data-name": "Ret\\xE2ngulo 1442",
  width: 12.297,
  height: 1.499,
  rx: 0.332,
  transform: "translate(230.703 151.578)",
  fill: "none",
  stroke: "#757575",
  strokeMiterlimit: 10,
  strokeWidth: 0.6,
  opacity: 0.97
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_942",
  "data-name": "Caminho 942",
  d: "M238.708,151.552v-.993c0-.032-.036-.059-.081-.059h-3.551c-.045,0-.081.027-.081.059v.993",
  fill: "none",
  stroke: "#757575",
  strokeMiterlimit: 10,
  strokeWidth: 0.6
}), /*#__PURE__*/React.createElement("line", {
  id: "Linha_82",
  "data-name": "Linha 82",
  y2: 9.801,
  transform: "translate(234.082 154.862)",
  fill: "none",
  stroke: "#757575",
  strokeMiterlimit: 10,
  strokeWidth: 0.6
}), /*#__PURE__*/React.createElement("line", {
  id: "Linha_83",
  "data-name": "Linha 83",
  y2: 9.801,
  transform: "translate(236.922 154.862)",
  fill: "none",
  stroke: "#757575",
  strokeMiterlimit: 10,
  strokeWidth: 0.6
}), /*#__PURE__*/React.createElement("line", {
  id: "Linha_84",
  "data-name": "Linha 84",
  y2: 9.801,
  transform: "translate(239.763 154.862)",
  fill: "none",
  stroke: "#757575",
  strokeMiterlimit: 10,
  strokeWidth: 0.6
}));

function SvgTrashcan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.897,
    height: 16.6,
    viewBox: "0 0 12.897 16.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashcan);
export default __webpack_public_path__ + "static/media/trashcan.c7db0103.svg";
export { ForwardRef as ReactComponent };